import LoaderSmall from './LoaderSmall';

export const LoaderScreen = () => {
  return (
    <div className="w-full py-10">
      <LoaderSmall />
    </div>
  );
};
